export default __webpack_public_path__ + "static/media/CarImages.PicantoMedium1.26b083ed.jpg";